module.exports = __webpack_public_path__ + "static/media/ydtg.a62ae9a.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/images/ydtg.mp4
// module id = auuj
// module chunks = 1